export enum Category {
  SIGATURE_PLATTER = 'MENU TRUFFLE CHICKEN BURGER',
  BURGER = 'BURGER',
  CORNDOG = 'CORNDOG',
  CHICKEN = 'CHICKEN',
  SIDE = 'PETIT FAIM',
  COCKTAIL = 'BIÈRE & COCKTAIL',
  MATCHA_SMOOTHIE = 'MATCHA & SMOOTHIE',
  DESSERT = 'DESSERT',
}

export interface Product {
  id: string;
  name: string;
  price: string;
  category: Category;
  description: string;
  images: string[];
  isVisible: boolean;
}

export interface SideByCategory {
  [key: string]: {
    description: string;
    cold: string[];
    hot: string[];
  };
}
